module.exports = __webpack_public_path__ + "static/media/action-delete-plan.f1d9c00f.svg";